export const getScreenWidth = () => window.screen.width